export const BASIC_SWEETALERT=[
    {
        text:"Print the basic message."
    }
]

//Title With A Text Under
export const TITLE_SWEETALERT=[
    {
        text:"Print the title with text."
    }
]

//Info Alerts
export const INFO_SWEETALERT=[
    {
        text:"Print the informational message."
    }
]

//Warning Alerts
export const WARNING_SWEETALERT=[
    {
        text:"Warning for imaginary files."
    }
]

//Pikachu Alert
export const PIKACHU_ALERT=[
    {
        text:"catch the pokeball."
    }
]

//Questions Alerts
export const QUESTIONS_ALERT=[
    {
        text:"Print the questionary and give answers."
    }
]

//Username Alerts
export const USERNAME_ALERT=[
    {
        text:"Print the basic sweet-alert"
    }
]

//Success Messages
export const SUCCESS_MESSAGES=[
    {
        text:"Print the success message."
    }
]

//Danger Alerts
export const DANGER_MESSAGES=[
    {
        text:"Print the danger message."
    }
]

//Warning Mode
export const WARNING_MODE=[
    {
        text:"Print the warning message."
    }
]

export const AUTO_CLOSE=[
    {
        text:"A text message with an automatic timer"
    }
]


//Ajax Request Movies
export const AJAX=[
    {
        text:"Give the movie name & return value."
    }
]